import { Filter, Stoplight } from '../../config/interfaces';

/**
 * Store sub context for stoplight data
 */
const StoplightContext = {
  stoplight: null as Stoplight | null,
  loadingStoplight: false,
  locationStoplights: [] as Stoplight[],
  totalCount: 0,
  sortKey: 'created',
  sortDir: 'desc',
  stoplightSearchQuery: '',
  currentStoplightPage: 1,
  loading: false,
  searchedStoplights: [] as Stoplight[],
  loadingStoplightShare: false,
  error: '',
  comment: null as any,
  loadingComment: false,
  stoplightFilter: {} as Filter,
  stoplightSharingQ: {},
  stoplightMetrics: {
    totalRecordsCount: 0,
    openedRecordsCount: 0,
    completedRecordsCount: 0,
    deferredRecordsCount: 0
  }
};

export default StoplightContext;
